// extracted by mini-css-extract-plugin
export default {"button":"button--dItnm","cookie-banner-wrapper":"cookie-banner-wrapper--6-7vm","cookieBannerWrapper":"cookie-banner-wrapper--6-7vm"};